import ApiResponseV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponseV2";
import GenericCrudServiceV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudServiceV2";
import HttpClientV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClientV2";
import FAQs from "../models/FAQs";

class AnniversariesService extends GenericCrudServiceV2<FAQs> {
  path: string;

  constructor(path: string) {
    super(path);
    this.path = path;
  }

  uploadTemplateImageToBackend(
    formData: any,
    fullNames:String[]
  ): Promise<ApiResponseV2<any>> {
    return HttpClientV2.post(`${this.basePath}/welcome-ensolvers?fullNames=${fullNames}`, formData);
  }
}

export default new AnniversariesService("/anniversaries");
